export class GrupoOperacao {
    Id: number;
    Descricao:string = "";
    EmpresaId: number;
    ProcessoPlanejamentoId: number;
    Ativo:boolean = true;
    Collapsed: boolean;
}
